export default __webpack_public_path__ + "static/media/pattern.719064fc.png";